export default __webpack_public_path__ + "static/media/Monika.b2e33297.jpg";